export default __webpack_public_path__ + "static/media/instructor-white.89017cd1.svg";